import { isAxiosError } from 'axios'

/** The backend's error body — `ApiExceptionHandler.ApiError` (D-061). */
interface ApiError {
  error?: string
  message?: string
  requestId?: string
}

/**
 * Pulls the server's own reason out of an axios error, falling back to a caller-supplied
 * generic string for anything without a response body (a network drop, an offline phone).
 *
 * <p>Before D-061 there was no `@ControllerAdvice`, so every written reason — "Delivery address
 * is required for delivery orders", "Cannot deactivate the last active owner" — was deleted
 * before it reached the browser and the fallback fired every time. It now arrives, along with a
 * `requestId` that greps straight to that request's log lines.
 *
 * <p>The request id is appended to the message rather than rendered separately: it has to reach
 * a shopkeeper who will read it aloud on the phone, and every error surface in the app already
 * renders one string. One helper therefore puts it everywhere at once.
 */
export function errorMessage(err: unknown, fallback: string): string {
  if (!isAxiosError(err)) {
    return fallback
  }
  const data = err.response?.data as ApiError | undefined
  const message = data?.message || data?.error || fallback
  return data?.requestId ? `${message} (ref: ${data.requestId})` : message
}
